export enum StorageKeys {
  DeviceUid = 'deviceUid',
  Code = 'code',
  AuthState = 'authState',
  ProcessId = 'processId',
  Order = 'order',
  Bot = 'bot',
  Authorized = 'authorized',
}
